var PageOrderEdit = (function ($) {

    PageOrderEdit = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_url = options['order_url'] || null;
        that.modals = options['modals'] || {};
        that.drawers = options['drawers'] || {};
        that.is_current_seance = options['is_current_seance'];
        that.is_exchange_enabled = options['is_exchange_enabled'];
        that.is_exchange_available = options['is_exchange_available'];
        that.selectors = {
            call_exchange: '.js-call-exchange',
            call_release_seats: '.js-call-release-seats'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$call_exchange = that.$wrapper.find(that.selectors.call_exchange);
        that.$call_release_seats = that.$wrapper.find(that.selectors.call_release_seats);

        // DYNAMIC VARS
        that.is_locked = false;

        // INIT
        that.init();
    };

    PageOrderEdit.prototype.init = function () {
        var that = this;

        that.initExchange();

        that.initReleaseSeats();
    };

    PageOrderEdit.prototype.initExchange = function () {
        var that = this;

        that.$call_exchange.on('click', function () {
            if (!that.is_exchange_enabled) {
                that.__showModal('exchange_disabled_service');
            } else if (!that.is_current_seance) {
                that.__showModal('exchange_invalid_seance');
            } else if (!that.is_exchange_available) {
                that.__showModal('exchange_passengers_checked');
            } else {
                if (that.is_locked) {
                    return;
                }

                that.is_locked = true;
                $.sa.buttonLoading(that.$call_exchange, true);

                that.__getExchangeDrawer().done(function (response) {
                    if (true === response) {
                        that.__showDrawer($(that.drawers['exchange']).clone());
                    } else {
                        that.__showModal('exchange_disabled_service');
                    }
                }).fail(function () {
                    that.__showModal('exchange_disabled_service');
                }).always(function () {
                    that.is_locked = false;
                    $.sa.buttonLoading(that.$call_exchange, false);
                });
            }
        });
    };

    /**
     * @private
     */
    PageOrderEdit.prototype.__getExchangeDrawer = function () {
        var that = this,
            deferred = $.Deferred(),
            exchange_url = that.order_url + 'exchange';

        $.get(exchange_url).done(function (response, textStatus, jqXHR) {
            if (200 === jqXHR.status && response.length) {
                that.drawers['exchange'] = response;
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    PageOrderEdit.prototype.initReleaseSeats = function () {
        var that = this;

        that.$call_release_seats.on('click', function () {
            if (that.is_locked) {
                return;
            }

            that.is_locked = true;
            $.sa.buttonLoading(that.$call_release_seats, true);

            that.__getReleaseSeatsDrawer().done(function (response) {
                if (true === response) {
                    that.__showDrawer($(that.drawers['release_seats']).clone());
                } else {
                    that.__showModal('release_seats_disabled_service');
                }
            }).fail(function () {
                that.__showModal('release_seats_disabled_service');
            }).always(function () {
                that.is_locked = false;
                $.sa.buttonLoading(that.$call_release_seats, false);
            });
        });
    };

    /**
     * @private
     */
    PageOrderEdit.prototype.__getReleaseSeatsDrawer = function () {
        var that = this,
            deferred = $.Deferred(),
            release_seats_url = that.order_url + 'releaseseats';

        $.get(release_seats_url).done(function (response, textStatus, jqXHR) {
            if (200 === jqXHR.status && response.length) {
                that.drawers['release_seats'] = response;
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     * @private
     */
    PageOrderEdit.prototype.__showModal = function (modal_name) {
        var that = this;

        $.uiModal({
            html: that.modals[modal_name]
        });
    };

    /**
     * @private
     */
    PageOrderEdit.prototype.__showDrawer = function ($wrapper) {
        $.uiDrawer({
            $wrapper: $wrapper,
            esc: false,
            position: 'right',
            size: 'large',
            mobile_fullscreen: true,
            onBgClick: function () {
                return false;
            }
        });
    };

    return PageOrderEdit;
})($);
